export default __webpack_public_path__ + "static/media/deposit-gpay-step1.9c385eee.png";